import script from "./CustomerDistribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistribution.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistribution.vue?vue&type=style&index=0&id=1ead53c6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ead53c6"]])

export default __exports__